import React, { useContext } from 'react';
import { EkonomiskAnalysSideMenuContext } from '../../../Context/EkonomiskAnalysSideMenuContext';
import EDStandardSelect from '../../../../../../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';
import {
  ISummationMode,
  SummationModeType,
  summationModes,
} from '../../../../../Utils/SummationModeUtils';

/**
 * Dropdownval av summeringsmetod
 */

interface IProps {}

const EkonomiskAnalysDetailSummationModeSelect: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = () => {
  const sideMenuContext = useContext(EkonomiskAnalysSideMenuContext);

  const { newAnalysSettings, onSummationModeChanged } = sideMenuContext;

  return (
    <EDStandardSelect<ISummationMode>
      label="Visa detaljer per"
      value={newAnalysSettings.other.summationMode}
      items={summationModes.map(sumMode => ({
        header: sumMode.displayName,
        value: sumMode,
      }))}
      onChange={newValue =>
        onSummationModeChanged(newValue as SummationModeType)
      }
    />
  );
};

export default EkonomiskAnalysDetailSummationModeSelect;
